<div class="information-card__container">
  <div class="information-card">
    <section class="information-card__content">
      <header class="information-card__header">
        <ng-content select="[header]"></ng-content>
      </header>
      <div class="information-card__body">
        <ng-content select="[body]"></ng-content>
      </div>
      <div class="button-container">
        <ng-content select="[container]"></ng-content>
      </div>
      <div class="information-card__footer">
        <ng-content select="[footer]"></ng-content>
      </div>
    </section>
  </div>
</div>
